import { lazy } from 'react'

export default lazy(
    () => 
    import('./CreateOrderViewB2B') 
)